import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="bg-paper py-16 sm:py-24" data-id="element-51" data-mp="1gd7hib8p3f72">
      <Container narrow data-id="element-52" data-mp="2e0fwdne6xq03">
        <SectionHeading id="faq-heading" eyebrow="Good to know" title="Frequently Asked Questions" data-id="element-53" data-mp="2e0ppvkyg2faj" />

        <ul className="mx-auto mt-11 max-w-[760px] space-y-3 sm:mt-14" data-id="element-54" data-mp="2913dteucr53b">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return <li key={faq.question} className={`overflow-hidden rounded-card border bg-white shadow-paper transition-colors ${isOpen ? 'border-clay/35' : 'border-hairline'}`} data-id="element-55" data-mp="snmm2svcupgw" data-mpi={index}>
                <h3 data-id="element-56" data-mp="pfv1k89pwubz">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="focus-ring flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-6" data-id="element-57" data-mp="uh0tw4zgufkz">
                    <span className="font-display text-[17px] font-semibold leading-snug text-ink sm:text-[19px]" data-id="element-58" data-mp="6plscefik2as">
                      {faq.question}
                    </span>
                    <span aria-hidden="true" className={`flex h-8 w-8 flex-none items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-claySoft text-clayDark' : 'bg-paper text-muted'}`} data-id="element-59" data-mp="3t0hhho62th8c">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-60" data-mp="1ugkuq37ului8" /> : <PlusIcon className="h-4 w-4" data-id="element-61" data-mp="1uhw88ur3igmj" />}
                    </span>
                  </button>
                </h3>

                {isOpen && <div id={panelId} role="region" aria-labelledby={buttonId} className="px-5 pb-6 sm:px-6" data-id="element-62" data-mp="1kr1df1zsa8ph">
                    <p className="max-w-[640px] text-[16px] leading-[1.68] text-muted sm:text-[17px]" data-id="element-63" data-mp="2dfgmz905bytf">
                      {faq.answer}
                    </p>
                  </div>}
              </li>;
        })}
        </ul>
      </Container>
    </section>;
}